export enum PriceSource {
    PRICE_BASE_VALUE = 0,
    PRICE_VALUE = 1,
    PRICE_TYPE_DISCOUNT = 2,
    PRICE_DISCOUNT = 3,
}
